import { Scope } from '@/types';

const renderScopeNumber = (v: Scope) =>
  ({
    scope1: 1,
    scope2: 2,
    scope3: 3,
  })[v];

const renderScope = (v: Scope) => `Scope ${renderScopeNumber(v)}`;

// The full scope set — single source of truth (the scenario scope-rule
// editor offers it as an axis). Mirrors village's `json::Scope` wire tokens.
const scopes: Scope[] = ['scope1', 'scope2', 'scope3'];

export { renderScope, renderScopeNumber, scopes };
